import { d } from 'typegpu';

export const DataCell = d.struct({
  r: d.f32,
  g: d.f32,
  b: d.f32,
  a: d.f32,
});
